<template>
  <div class="div-class">
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="main">
      <div class="leftmenu">

        <div class="menu-class">
          <a class="a-menu-class">单据下发</a>
        </div>

        <!--        <ul>-->
        <!--          <li class="nav_item"><a href="#">单据下发</a><span class="jt"></span></li>-->
        <!--          <li class="nav_item"><a href="#"></a><span class="jt"></span></li>-->
        <!--          <li class="nav_item"><a href="#"></a><span class="jt"></span></li>-->
        <!--          <li class="nav_item"><a href="#"></a><span class="jt"></span></li>-->
        <!--          <li class="nav_item"><a href="#"></a><span class="jt"></span></li>-->
        <!--        </ul>-->

      </div>
      <div class="rightmenu">
        <div class="">
          <div>单据下发</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Navigation from "../component/Navigation";
import LogoHome from "../component/LogoHome";
import {billOrders, getBillNo,saveBill} from '../../api';
export default {
  components:{
    ShortCut,
    Navigation,
    LogoHome
  },
  data(){
    return{

    }
  },
  methods:{

  },
  mounted(){

  }
}
</script>

<style>
.nav_item{
  /*border: 1px solid black;*/
  /*margin-left: 10%;*/
  /*width:70px;*/
  height:41px;
  line-height:41px;
  color:white;
  list-style-type:none
}
.leftmenu{
  background: #f1f1f1;
  width: 130px;
  margin-left: 10%;
  height: 100%;
}
.main{
  height: 100%;
  width: 100%;
}
.menu-class{
  height: 41px;
  line-height: 41px;
  border-bottom: 1px solid #e9e8e9;
  font-size: 15px;
  /*display: flex;*/
}
/*.menu-class>a:visited{*/
/*  color:#fff*/
/*}*/
.a-menu-class{
  cursor:pointer;
}
.a-menu-class:hover{
  /*color: #ffeac2;*/
  text-decoration: underline;
}
.a-menu-class:visited{
  /*color: #e9e8e9 !important;*/
  /*text-decoration: underline;*/
  background-color:yellow;
}
.rightmenu{

}
.div-class{

}
</style>



// WEBPACK FOOTER //
// src/components/order/billIssue.vue